<template>
  <v-container>
    <v-row class="mt-6" justify="center" no-gutters>
      <v-col lg="8">
        <v-card flat class="ma-3 pa-4">
          <v-container>
            <v-row class="mt-3" justify="center" no-gutters>
              <v-col cols="12" xl="6" lg="8" md="8" sm="8">
                <v-card flat>
                  <v-card-title class="text-center justify-center py-">
                    <div class="text-h4 mt-5 primary--text" style="display: block">
                      {{ $t('login.title') }}
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <Login />
                    <!-- <v-container>
                        <v-row class="mt-0" justify="center">
                          <h4 justify="center"><span>{{ $t('login.or') }}</span></h4>
                          <v-btn text class="title" to="/auth/register">
                            {{ $t('login.registerAccount') }}
                          </v-btn>
                        </v-row>
                    </v-container> -->
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiOpenInNew } from '@mdi/js';

const Login = () => import(/* webpackChunkName: "component-auth-Login" */ '@codehq/aurora-app-core/src/components/Login.vue');

export default {
  name: 'login',
  components: {
    Login,
  },
  data() {
    return {
      mdiOpenInNew,
    };
  },
};
</script>
